import apiClient from '@lib/apiClient';
import { RawSpeechTokenResponse } from '@services/types';

import { AvatarApiUrl } from './endpoints';
import { AvatarSupportedLocalesResponse } from './types';

export const getAvatarTokenAndRegion = async (): Promise<RawSpeechTokenResponse> => {
    const response = await apiClient.get<RawSpeechTokenResponse>(AvatarApiUrl.AvatarTokenAndRegion);
    return response.data;
};

export const getAvatarSupportedLocales = async (): Promise<AvatarSupportedLocalesResponse> => {
    const response = await apiClient.get<AvatarSupportedLocalesResponse>(
        AvatarApiUrl.AvatarSupportedLocales
    );
    return response.data;
};
